<template>
  <div class="text-muted font-sm">
    <div>
      <translate>This site is protected by reCAPTCHA</translate>
    </div>
    <div v-if="fieldHasError('token')" class="text-danger">
      {{ getFieldError("token") }}
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters("form", ["getFieldError", "fieldHasError"])
  }
};
</script>
